<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
            select-mode="single" selectable @row-selected="onRowSelected" show-empty>

            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay documentos que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha subido ningún documento
                </b-card>
            </template>

            <!--icono de carque de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>

        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js'

export default {
    name: 'DocumentNotificationTable',

    components:{
        AlertDismiss
    },

    data() {
        return {
            isBusy: false,
            items: [],
            selected: [],

            //datos de filtro aqui
            searchQuery: '',

            fields: [
                {
                    key: 'sent',
                    label: 'Enviado' , formatter: (value) => {
                        return value ? 'Si' : 'No'
                    }
                },
                { key: 'description', label: 'Descripción' },
                { key: 'documentName', label: 'Nombre del Documento' },
                { key: 'documentType', label: 'Tipo de Documento' },
                { key: 'visitorMail', label: 'Correo electrónico del usuario' },

                {
                    key: 'agreedDateFormat',
                    label: 'Fecha envío',
                    formatter: (value) => {
                        return value;
                    }
                },
            ]
        }
    },

    async mounted(){
        this.$eventBus.$on(EventNames.FilterSendDocumentAfterSearch, (query) => {
            this.processingTable();

            this.searchQuery = query

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.PaginationFilterSendDocument, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getAllNotification(page, pageSize);

            this.processingTable();
        });
    },

    computed: {
        filteredItems() {
            let filtered = this.items;

            // Filtrar por búsqueda por nombre, apellido, etc.
            if (this.searchQuery) {
                filtered = this.filterForSearch(filtered, this.searchQuery)
            }

            return filtered;
        }
    },

    methods:{
        ...mapActions(["allDocumentNotification"]),

        onRowSelected(items) {
            this.selected = items;
        },

        async getAllNotification(page, pageSize){
            this.items = []

            let result = await this.allDocumentNotification({
                page: page,
                pageSize: pageSize
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            let notifications = result.data.map((notif) => {
                return{
                    id: notif.id,
                    sent: notif.sent,
                    description: notif.description,
                    documentName: notif.document.name,
                    documentType: notif.document.type,
                    visitorMail: notif.visitor.mail,
                    agreedDateFormat: this.formatDate(notif.creationDate)

                }
            });

            this.items = [...notifications]
        },

        formatDate(date) {
            if (date == null) {
                return;
            }

            // Crear un objeto Date con la fecha y hora ISO
            var fechaHora = new Date(date);

            // Formatear la fecha y hora en un formato legible para el usuario
            var opcionesFormato = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            return fechaHora.toLocaleDateString('es-ES', opcionesFormato);
        },

        processingTable() {
            this.isBusy = !this.isBusy
        },

        filterForSearch(sendDocumentos, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            return sendDocumentos.filter(item =>
                Object.values(item).some(value =>
                    value.toString().toLowerCase().includes(normalizedQuery)
                )
            );
        },
    }
}
</script>
<style>
    
</style>
